import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const CurrentOverloadTooltip = ({ rangeStr, maxValue, quadMeanValue }) => {
    const { t: translate } = useTranslation();
    return (
        <div className='current-overload-tooltip'>
            <div className='current-overload-tooltip__range'><strong>{rangeStr}</strong></div>
            <div className='current-overload-tooltip__row'>
                <span
                    className='current-overload-tooltip__symbol'
                    style={{
                        background: '#E87FE8',
                        display: 'inline-block',
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        marginRight: 8,
                        verticalAlign: 'middle'
                    }}
                />
                {translate('ABB.Powertrain.Frontend.CurrentOverloadTooltipMax')}: <span>{maxValue} %</span>
            </div>
            <div className='current-overload-tooltip__row'>
                <span
                    className='current-overload-tooltip__symbol'
                    style={{
                        background: '#1F5A99',
                        display: 'inline-block',
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        marginRight: 8,
                        verticalAlign: 'middle'
                    }}
                />
                {translate('ABB.Powertrain.Frontend.CurrentOverloadTooltipQuadraticMean')}: <span>{quadMeanValue} %</span>
            </div>
        </div>
    );
};

export default CurrentOverloadTooltip;
